import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=5a79cc56&"
import script from "./top-header.vue?vue&type=script&lang=js&"
export * from "./top-header.vue?vue&type=script&lang=js&"
import style0 from "./top-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports